import React from 'react';
import PropTypes from 'prop-types';

import styles from '../../assets/styles/colors.scss';
import './LocationMapCluster.scss';

export default class LocationMapCluster extends React.Component {

  constructor(props) {
    super(props);
    LocationMapCluster.propTypes = {
      lat: PropTypes.number,
      lng: PropTypes.number,
      /** Array of geoJSON objects. Each MUST have an AO location object in its properties */
      locationsGeoJSON: PropTypes.arrayOf(PropTypes.object),
    };
  }

  render() {
    const { locationsGeoJSON } = this.props;

    let notStartedProjectCount = 0;
    let inProgressProjectCount = 0;
    let completedProjectCount = 0;
    
    for (let locationPoint of locationsGeoJSON) {
      const location = locationPoint.geometry.properties.location;
      notStartedProjectCount += location.not_started_projects_count;
      inProgressProjectCount += location.in_progress_projects_count;
      completedProjectCount += location.completed_projects_count;
    }

    let clusterColor = styles.nonExistant;
    if (inProgressProjectCount > 0) {
      clusterColor = styles.inProgress;
    }
    else if (completedProjectCount > 0) {
      clusterColor = styles.complete;
    }
    const projectsAtClusterCount = notStartedProjectCount + inProgressProjectCount + completedProjectCount;
    return (
      <div className="location-cluster" style={{ backgroundColor: clusterColor }} >
        <div className="location-cluster__count">
          {projectsAtClusterCount}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LocationMapCluster/index.js